import { render, staticRenderFns } from "./FaqsTab.vue?vue&type=template&id=693f0564&"
import script from "./FaqsTab.vue?vue&type=script&lang=js&"
export * from "./FaqsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports